import { LoadCartProps } from '../../../types';
import {
  COOKIES_NAMES,
  getActiveCartId,
  getActiveUserId,
  getCookie,
  setCookie
} from '../../../helpers';
import { GetCartProps } from '@vsf-enterprise/sapcc-api';
import { Cart } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { Context } from '@vue-storefront/core';

export async function loadCart(
  context: Context,
  params: LoadCartProps,
  useCartId?: string
): Promise<Cart> {
  const {
    $sapcc: {
      config: { $cookies }
    }
  } = context;

  const cartCookieName = `${COOKIES_NAMES.CART_ID}-${useCartId}`;

  const props: GetCartProps = {
    ...params,
    userId: getActiveUserId($cookies),
    cartId: getCookie({ cookies: $cookies, name: cartCookieName }),
  };

  const currentCart = await context.$sapcc.api.getCart(props);

  if (useCartId) {
    setCookie({
      cookies: $cookies,
      name: cartCookieName,
      value: getActiveCartId({ cookies: $cookies, currentCart })
    });
  }

  return currentCart;
}
